import { useAws } from "src/networking/aws";
import {
  AwsGateCallbacks,
  AwsGateRequest,
  GetCheckoutDetails,
  PostCreateCheckout,
} from "src/types";
export const usePostCreateCheckout = <
  T extends PostCreateCheckout["request"],
  D extends PostCreateCheckout["response"]
>() => {
  const hook = useAws<T, D>("postCreateCheckout");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "post",
          path: `/quote/${request.uriParams.idPolizza}`,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const useGetCheckoutDetails = <
  T extends GetCheckoutDetails["request"],
  D extends GetCheckoutDetails["response"]
>() => {
  const hook = useAws<T, D>("getCheckoutDetails");

  return {
    ...hook,
    crossGate: (request: AwsGateRequest<T>, callbacks: AwsGateCallbacks<D>) => {
      return hook.crossGate(
        {
          method: "get",
          path: `/quote/checkout/${request.uriParams.checkoutSessionId}`,
          ...request,
        },
        callbacks
      );
    },
  };
};
